import type { TenantBlueprint } from "./arkaTenantBlueprint";

/** Catálogo con recompra. Un solo tablero: persona y empresa son tarjetas. */
export const naiuTenantBlueprint: TenantBlueprint = {
  title: "NAIU CRM",
  currency: "COP",
  companySectors: [
    { value: "tienda", label: "Tienda / retail" },
    { value: "distribuidor", label: "Distribuidor" },
    { value: "horeca", label: "Restaurante / café" },
    { value: "bienestar", label: "Bienestar / gimnasio" },
    { value: "otro", label: "Otra empresa" },
  ],
  dealStages: [
    { value: "captured", label: "Captado" },
    { value: "conversation", label: "En conversación" },
    { value: "cart", label: "Carrito armado" },
    { value: "proposal", label: "Propuesta" },
    { value: "payment", label: "Pago verificado" },
    { value: "won", label: "Despachado" },
    { value: "active", label: "Cliente activo" },
    { value: "repurchase", label: "Por recomprar" },
    { value: "lost", label: "Perdido" },
  ],
  dealPipelineStatuses: ["won", "lost"],
  dealCategories: [
    { value: "detal", label: "Persona / catálogo" },
    { value: "empresa", label: "Empresa / mayorista" },
  ],
  noteStatuses: [
    { value: "cold", label: "Frío", color: "#8B9CB3" },
    { value: "warm", label: "Tibio", color: "#7EC8E3" },
    { value: "hot", label: "Caliente", color: "#00AAFF" },
    { value: "in-contract", label: "Ya compró", color: "#12B886" },
  ],
  taskTypes: [
    { value: "none", label: "Ninguno" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "call", label: "Llamada" },
    { value: "follow-up", label: "Seguimiento" },
  ],
  wonFollowUp: {},
};
